<template>
    <div style="width:100%" class="mb-4">

        <v-card class="mx-auto" width="100%">
            <v-card-text>
                <div class="text-h5">IC Report</div>
            </v-card-text>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Incident</v-list-item-title>
                    <v-list-item-subtitle> {{$route.params.id}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Incident Description</v-list-item-title>
                    <v-list-item-subtitle> {{data.incidentTitle}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Severity</v-list-item-title>
                    <v-list-item-subtitle> {{data.incidentSeverity}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Affected Operator</v-list-item-title>
                    <v-list-item-subtitle>
                        <v-chip class="ma-1" :key="operator" small v-for="operator in affectedOperatorArray">
                            {{ operator }}
                        </v-chip>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Affected Site</v-list-item-title>
                    <v-list-item-subtitle> {{data.affectedSite}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Impact</v-list-item-title>
                    <v-list-item-subtitle> {{data.mttrMinutes}} Min</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Root Cause</v-list-item-title>
                    <v-list-item-subtitle> {{data.rootCause}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>IC</v-list-item-title>
                    <v-list-item-subtitle> {{data.incidentCommander}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>SME</v-list-item-title>
                    <v-list-item-subtitle> {{data.subjectMatterExpert}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Status</v-list-item-title>
                    <v-list-item-subtitle>

                        <v-chip v-if="data.mttrA" class="ma-1 green" small>
                            Up to Date
                        </v-chip>

                        <v-chip v-if="!data.mttrA" class="ma-1 danger" small>
                            Out of Date
                        </v-chip>

                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Date Logged</v-list-item-title>
                    <v-list-item-subtitle> {{data.incidentStartDate | DateTime}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title>Added By</v-list-item-title>
                    <v-list-item-subtitle> {{data.psrCompletedBy}}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>

            <!--<v-card-actions>
                <v-btn text
                       color="accent"
                       @click="onOpenPostSev">
                    Post Sev: {{$route.params.id }}
                </v-btn>
            </v-card-actions>-->

        </v-card>

    </div>
</template>

<script>
    export default {
        name: 'IncidentReport',
        data: function () {
            return {

            }
        },
        props: {
            data: {
                default: () => {},
                type: Object
            }
        },
        computed: {
            affectedOperatorArray() {
                if (!this.data.affectedOperator) return [];
                return this.data.affectedOperator.replace("[", "").replace("]", "").replace(/"/g, "").split(',').filter(operator => operator !== "");
            }
        },
        methods: {
            async onOpenPostSev() {
                window.open(`https://postsev.derivco.com/${this.$route.params.id}`);
            }
        }
    }
</script>
